import { useEffect } from 'react'
import { REACT_APP_ALLOW_SEARCH_INDEXING } from '../../envVariables'
import { META_ROBOTS_MANAGED_BY } from '../../utils/constants/constants'

const SearchIndexingMeta = () => {
  const allowSearchIndexing =
    (REACT_APP_ALLOW_SEARCH_INDEXING ?? '').trim().toLowerCase() === 'true'

  useEffect(() => {
    const robotsMeta = document.querySelector<HTMLMetaElement>(
      'meta[name="robots"]',
    )

    // Case 1: indexing allowed → remove only the tag we manage (if present)
    if (allowSearchIndexing) {
      if (robotsMeta?.dataset.managedBy === META_ROBOTS_MANAGED_BY) {
        robotsMeta.remove()
      }
      return
    }

    // Case 2: indexing NOT allowed, robots tag exists → update & mark as managed
    if (robotsMeta) {
      robotsMeta.content = 'noindex, nofollow'
      robotsMeta.dataset.managedBy = META_ROBOTS_MANAGED_BY
      return
    }

    // Case 3: indexing NOT allowed, no robots tag → create one
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, nofollow'
    meta.dataset.managedBy = META_ROBOTS_MANAGED_BY
    document.head.appendChild(meta)
  }, [allowSearchIndexing])

  return null
}

export default SearchIndexingMeta
